function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.00321198 7.16212C0.00126266 6.94224 0.0905471 6.72987 0.253051 6.56786L2.90884 4L0.253051 1.43214C0.090333 1.2706 0 1.05898 0 0.839314C0 0.61965 0.090333 0.408024 0.253051 0.246489C0.330874 0.168807 0.425505 0.10678 0.530934 0.0643464C0.636364 0.0219127 0.750287 0 0.865469 0C0.98065 0 1.09457 0.0219127 1.2 0.0643464C1.30543 0.10678 1.40006 0.168807 1.47789 0.246489L4.74578 3.40746C4.90918 3.56834 5 3.77982 5 3.99943C5 4.21904 4.90918 4.43052 4.74578 4.5914L1.48101 7.75351C1.40319 7.83119 1.30855 7.89322 1.20313 7.93565C1.0977 7.97809 0.983773 8 0.868591 8C0.75341 8 0.639486 7.97809 0.534057 7.93565C0.428628 7.89322 0.333997 7.83119 0.256174 7.75351C0.0938692 7.59253 0.00455379 7.38111 0.00633526 7.16212",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-right-3.bd57bdab.svg";
export { SvgComponent as ReactComponent };